


















































































































import Vue, { PropType } from "vue";
import { KEYCODE } from "@/constants/event";

import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import NumberText from "@/components/Atoms/Typography/Number/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading,
    NumberText,
    SpeechBubble,
    Suffix,
    Body,
    Button,
    ButtonConfig
  },
  props: {
    eventType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    fromDate: {
      type: Date,
      required: true
    },
    toDate: {
      type: Date,
      required: true
    },
    note: {
      type: String,
      required: true
    },
    speechBubble: {
      type: Object as PropType<Props["speechBubble"]>,
      required: true
    }
  },
  computed: {
    isEditEventViewVisible() {
      return this.$store.state.pages.plan.isEditEventViewVisible;
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handlePressEsc);
  },
  methods: {
    handleClickEditEventViewOpen() {
      this.$emit("clickEditEventViewOpen");
    },
    handlePressEsc(event) {
      if (event.keyCode !== KEYCODE.ESC || this.isEditEventViewVisible) {
        return;
      }
      this.$emit("clickOwnOrganizationSpeechBubbleClose");
    }
  }
});
